import { render, staticRenderFns } from "./popupPay.vue?vue&type=template&id=51be48e8&scoped=true"
import script from "./popupPay.vue?vue&type=script&lang=js"
export * from "./popupPay.vue?vue&type=script&lang=js"
import style0 from "./popupPay.vue?vue&type=style&index=0&id=51be48e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be48e8",
  null
  
)

export default component.exports